export default __webpack_public_path__ + "static/media/logo.fa40a53c.png";